module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_kyodomura-b89a4f6b1bd2cd1e167700f636bb210a.jpg";